import { Injectable } from '@angular/core';
import { DataEntryStore } from './data-entry.store';
import { SbStepState } from '../components/sb-step-indicator/sb-step-indicator.component';
import { DataEntryQuery } from './data-entry.query';
import { BehaviorSubject } from 'rxjs';
import { ConfirmationDetails } from 'src/app/shared/forms/types/base-types';

@Injectable()
export class DataEntryService {
    private _formDetailsSubject$ = new BehaviorSubject<ConfirmationDetails[]>(null);
    currentFormDetails$ = this._formDetailsSubject$.asObservable();
    constructor(
        private dataEntryStore: DataEntryStore,
        private dataEntryQuery: DataEntryQuery
    ) {}
    updateActive(state: SbStepState) {
        const id = this.dataEntryQuery.getActiveId() as string;
        this.dataEntryStore.upsert(id, { state });
    }

    updateFormDetails(details: ConfirmationDetails[]) {
        this._formDetailsSubject$.next(details);
    }

    resetFormDetails() {
        this._formDetailsSubject$.next(null);
    }
}
